(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var reveal = document.getElementById('snfReveal');
    if(!reveal) return;
    var observer = new MutationObserver(function(){
      if(!reveal.classList.contains('show')) return;
      var nameEl = document.getElementById('snfName2');
      if(!nameEl || nameEl.textContent.trim() !== 'The Siren') return;
      if(reveal.dataset.sirenPatched) return;
      reveal.dataset.sirenPatched = '1';
      var pname = document.getElementById('snfPname'), pprice = document.getElementById('snfPprice'), buy = document.getElementById('snfBuy'), img = document.getElementById('snfImg');
      if(pname) pname.textContent = 'The Siren \u2014 Coming Soon';
      if(pprice) pprice.textContent = 'Notes not yet announced';
      if(img) img.style.opacity = '0.35';
      if(buy){
        buy.removeAttribute('href');
        buy.style.opacity = '0.5';
        buy.style.pointerEvents = 'none';
        buy.textContent = 'Coming Soon';
      }
    });
    observer.observe(reveal, { attributes: true, attributeFilter: ['class'] });
  });
})();
